module.exports = __webpack_public_path__ + "img/employee-empty-illustration.ba4170ff.svg";